import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import { observable } from 'mobx'

import { client } from '@authy/lib-client/trpc'

import { rootRoute as applicationsRootRoute } from '@/tenant/applications/root'
import { appState } from '@/appState'

export const rootRoute = createRoute({
    getParentRoute: () => applicationsRootRoute,
    path: '/$applicationId',
    component: lazyRouteComponent(() => import('./Root'), 'Root'),
    beforeLoad: async ({ location }): Promise<void> => {
        if (!location.pathname.split('/')[4]) {
            throw redirect({
                replace: true,
                to: '/$tenantShortId/applications/$applicationId/general',
                params: {
                    tenantShortId: appState.tenant!.shortId,
                    applicationId: location.pathname.split('/')[3],
                },
            })
        }
    },
    loader: async ({ abortController, params: { applicationId } }) => {
        const tenantId = appState.tenant!._id.toString()

        const [application, { resources }] = await Promise.all([
            client.applications.getApplication.query(
                {
                    tenantId,
                    applicationId,
                },
                { signal: abortController?.signal }
            ),
            client.applications.getApplicationApiOptions.query(
                {
                    tenantId,
                },
                { signal: abortController?.signal }
            ),
        ])

        return observable({
            application,
            availableResources: resources,
        })
    },
})
